export const VIREMENT = 3
export const DEPOT = 2
export const MOBILE = 1
export const TYPE_PAYMENT_MOBILE = 2
export const TYPE_PAYMENT_BANK = 3
export const REFILL_REPOSITORY_NAME = 'recharge-compte-financier'
